import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of, throwError, catchError, tap } from 'rxjs';
import { jwtDecode } from 'jwt-decode';
import { JwtPayload } from '../../interfaces/JwtPayload';
import { environment } from '../../../environments/environment';
import { UserService } from '../repositories/user.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private apiUrl = environment.apiUrl;
  userSubject = new BehaviorSubject<any>(null)
  userSubject$ = this.userSubject.asObservable();
  public currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<any | null>; 

  constructor(private http: HttpClient, private userService: UserService) {
    const token = window.localStorage.getItem('token');
    this.currentUserSubject = new BehaviorSubject<any | null>(null);
    this.currentUser = this.currentUserSubject.asObservable();

    if (token && this.isTokenValid(token)) {
      this.loadCurrentUser().subscribe();
    }
  }
  loadedUser: any = {};

  getLoadedUser(): any {
    return this.currentUserSubject.value;
  }
  savetoLs(user:any){
    let sessionData = localStorage.getItem(environment.sessionData)
    if(!sessionData ){
      localStorage.setItem(environment.sessionData, JSON.stringify({user}))
    }
    else if(sessionData!=null){

      const sessionObj = JSON.parse(sessionData)

      localStorage.setItem(environment.sessionData, JSON.stringify({...sessionObj,user}))
    }
  }
  loadUserfromLs(){
    const sessionData = localStorage.getItem(environment.sessionData)
    if(sessionData){
      const ls =  JSON.parse(sessionData);
       //console.log("user UI on LS",ls.user.UI);
      return ls.user
    }
  }

  loadCurrentUser(): Observable<any | null> {
    

    // Get the connected user ID
    const userId = this.connectedUserId();

    // If the user ID is valid (non-zero), fetch the user from backend
    if (userId !== 0) {
      return this.userService.getUserById(userId).pipe(
        tap((user) => {
          //set all ui permissions
          
          //encrypt the user
          this.loadedUser = user; // Cache the loaded user
          this.userSubject.next(user);

          this.currentUserSubject.next(user); // Update the user observable
        })
      );
    } else {
      // If no user ID, set the current user to null
      this.currentUserSubject.next(null);
      return of(null);
    }
  }

  login(username: string, password: string): Observable<any> {
    const loginData = { email: username, password: password };
    return this.http.post<any>(`${this.apiUrl}/auth/login`, loginData).pipe(
      tap((response) => {
        if (response.token) {
          localStorage.setItem('token', response.token);
          this.loadCurrentUser().subscribe((res) => {
            if(res.data.isAdmin)
              res.data.accreditations = []
            
            this.currentUser = res.data;
            const today = new Date();
            const ls={
              user:res.data,
              language:res.data.lang,
              filterData:{
                dateRange:{
                  startDate:new Date(today.getFullYear()-2, 11, 31).toISOString(),
                  endDate:new Date(today.getFullYear(), 11, 31).toISOString()
                },
                pageStatsdateRange:{
                  pageStatsendDate:new Date(today.setDate(today.getDate() - 30)).toISOString(),
                  pageStatsstartDate:new Date(today.setDate(today.getDate() - 2)).toISOString()
                },
                platformsFilter:{isLinkedinON:true,isGoogleON:true,isFacebookON:true,isInstagramON:true},
                postTypes:{isPlanned:true,isPosted:true,isDraft:true,isFailed:false},

              }

            }
            console.log("saving..",ls)
            localStorage.setItem(environment.sessionData,JSON.stringify(ls));
          });
        }
      })
    );
  }

  logout(): void {
    localStorage.removeItem('token');
    localStorage.removeItem(environment.sessionData)
    this.currentUserSubject.next(null);
  }

  isTokenValid(token: string): boolean {
    try {
      const decodedToken = jwtDecode(token) as JwtPayload;
      if (decodedToken && decodedToken.exp) {
        const currentTime = Date.now() / 1000; // seconds
        return decodedToken.exp > currentTime;
      }
    } catch (error) {
      console.error('Error validating token:', error);
    }
    localStorage.removeItem('token');
    return false;
  }

  connectedUserId(): number {
    const token = localStorage.getItem('token');
    if (token) {
      const decodedToken = jwtDecode(token) as JwtPayload;
      return decodedToken.userId;
    }
    return 0;
  }



  resetPasswordEmail(email: string): Observable<Response> {
    return this.http.get<Response>(`${this.apiUrl}/auth/reset-password/${email}`).pipe(
      catchError((error) => {
        console.error('Error fetching user:', error);
        return throwError(() => error);
      })
    );
  }

  getAlertContacts():Observable<any>{
    return this.http.get<any>(`${this.apiUrl}/auth/alert-contacts`).pipe(
      catchError((error) => {
        console.error('Error fetching alert contacts:', error);
        return throwError(() => error);
      })
    );
  }
  newAlertContact(email:string){
    return this.http.post<any>(`${this.apiUrl}/auth/alert-contacts/new`,{email}).pipe(
      catchError((error) => {
        console.error('Error creating new alert contact:', error);
        return throwError(() => error);
      })
    );
  }
   updateAlertContact(id:Number,email:string){
    return this.http.patch<any>(`${this.apiUrl}/auth/alert-contacts/update/${id}`,{email}).pipe(
      catchError((error) => {
        console.error('Error creating new alert contact:', error);
        return throwError(() => error);
      })
    );
  }

    destroyAlertContact(id:Number){
    return this.http.delete<any>(`${this.apiUrl}/auth/alert-contacts/destroy/${id}`).pipe(
      catchError((error) => {
        console.error('Error creating new alert contact:', error);
        return throwError(() => error);
      })
    );
  }
  checkResetPasswordToken(token: string): Observable<Response> {
    return this.http.get<Response>(`${this.apiUrl}/auth/check-password-token/${token}`).pipe(
      catchError((error) => {
        console.error('Error fetching user:', error);
        return throwError(() => error);
      })
    );
  }

  resetPassword(userId: number, newPassword: string): Observable<any> {
    return this.http.patch(`${this.apiUrl}/auth/password/${userId}`, {
      newPassword,
    });
  }

  deleteResetedPasswordToken(token: any): Observable<any> {
    return this.http.delete(`${this.apiUrl}/auth/delete-password-token/${token}`);
  }

  allLoginActivities(): Observable<any> {
    return this.http.get(`${this.apiUrl}/auth/all-login-activities`);
  }

  deleteLog(id: any): Observable<any> {
    return this.http.delete<Response>(`${this.apiUrl}/auth/delete-log/${id}`).pipe(
      catchError((error) => {
        console.error('Error deleting Log Activity:', error);
        return throwError(() => error);
      })
    );
  }
  
  allConnectedUsers(): Observable<any> {
    return this.http.get(`${this.apiUrl}/auth/all-connected-users`);
  }
  
  deleteCurrentConnectedUser(token: any): Observable<any> {
    return this.http.delete<Response>(`${this.apiUrl}/auth/delete-connected-user/${token}`).pipe(
      catchError((error) => {
        console.error('Error deleting Current Connected User:', error);
        return throwError(() => error);
      })
    );
  }
}
